export const after_device_add_dialog_reducer = (state = {
    open: false,
    sim_in_device_type: 'billed',
    msisdn: '',
    sim_id: undefined,
}, action) => {
    switch (action.type) {
        case 'SIM_AFTER_DEVICE_ADD__OPEN':
            return {
                open: true,
                sim_in_device_type: action.sim_in_device_type,
                msisdn: action.msisdn,
                sim_id: action.sim_id,
            };
        case 'SIM_AFTER_DEVICE_ADD__CLOSE':
            return { ...state, open: false };
        default:
            return state;
    }
};
